import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Sidebar from '../../components/dashboard/Sidebar';
import Navbar from '../../components/dashboard/Navbar';
import Home from './Home';
import { authService } from '../../services/auth.service';

// Admin pages
import AdminDashboard from '../admin/AdminDashboard';
import Users from '../admin/Users';
import Approvals from '../admin/Approvals';
import Invites from '../admin/Invites';
import Departments from '../admin/Departments';
import Roles from '../admin/Roles';
import AdminDocuments from '../admin/Documents';
import AdminTasks from '../admin/Tasks';
import AdminLeaves from '../admin/Leaves';
import AdminManagerLeaves from '../admin/ManagerLeaves';
import AllAttendance from '../admin/AllAttendance';
import AdminClients from '../admin/AdminClients';
import BlogApprovals from '../admin/BlogApprovals';
import ManageBlogs from '../admin/ManageBlogs';
import EmployeePerformance from '../admin/EmployeePerformance';
import FreelancerHub from '../admin/FreelancerHub';
import PermissionManagement from '../admin/PermissionManagement';

// Manager pages
import ManagerDashboard from '../manager/ManagerDashboard';
import ManagerTeam from '../manager/ManagerTeam';
import ManagerLeaves from '../manager/ManagerLeaves';

// Employee pages
import MyAttendance from '../employee/MyAttendance';
import MyTasks from '../employee/MyTasks';
import MyLeaves from '../employee/MyLeaves';
import MyDocuments from '../employee/MyDocuments';
import MyClients from '../employee/MyClients';
import CreateEditBlog from '../employee/CreateEditBlog';
import MyBlogs from '../employee/MyBlogs';
import AllBlogs from '../employee/AllBlogs';
import ViewBlog from '../employee/ViewBlog';
import EmployeeForum from '../employee/EmployeeForum';
import FridayFunZone from '../employee/FridayFunZone';



const Dashboard = () => {
    const user = authService.getCurrentUser();
    const isAdmin = user?.role?.name === 'super_admin' || user?.role?.name === 'admin';
    const isManager = user?.role?.name?.includes('manager');

    const getDefaultDashboard = () => {
        if (isAdmin) return <AdminDashboard />;
        if (isManager) return <ManagerDashboard />;
        return <Home />;
    };

    return (
        <div className="flex h-screen bg-gray-100">
            <Sidebar />
            <div className="flex-1 flex flex-col overflow-hidden">
                <Navbar />
                <main className="flex-1 overflow-y-auto">
                    <Routes>
                        <Route path="/" element={getDefaultDashboard()} />

                        {/* Admin Routes */}
                        <Route path="/admin" element={<AdminDashboard />} />
                        <Route path="/admin/users" element={<Users />} />
                        <Route path="/admin/approvals" element={<Approvals />} />
                        <Route path="/admin/invites" element={<Invites />} />
                        <Route path="/admin/departments" element={<Departments />} />
                        <Route path="/admin/roles" element={<Roles />} />
                        <Route path="/admin/documents" element={<AdminDocuments />} />
                        <Route path="/admin/tasks" element={<AdminTasks />} />
                        <Route path="/admin/leaves" element={<AdminLeaves />} />
                        <Route path="/admin/manager-leaves" element={<AdminManagerLeaves />} />
                        <Route path="/admin/attendance" element={<AllAttendance />} />
                        <Route path="/admin/clients" element={<AdminClients />} />
                        <Route path="/admin/EmployeePerformance" element={<EmployeePerformance />} />
                        <Route path="/admin/FreelancerHub" element={<FreelancerHub />} />
                        <Route path="/admin/PermissionManagement" element={<PermissionManagement />} />

                        {/* Manager Routes */}
                        <Route path="/manager" element={<ManagerDashboard />} />
                        <Route path="/manager/team" element={<ManagerTeam />} />
                        <Route path="/manager/tasks" element={<AdminTasks />} />
                        <Route path="/manager/leaves" element={<ManagerLeaves />} />
                        <Route path="/manager/attendance" element={<AllAttendance />} />

                        {/* Employee Routes */}
                        <Route path="/attendance" element={<MyAttendance />} />
                        <Route path="/tasks" element={<MyTasks />} />
                        <Route path="/leaves" element={<MyLeaves />} />
                        <Route path="/documents" element={<MyDocuments />} />
                        <Route path="/clients" element={<MyClients />} />
                        <Route path="/blogs" element={<MyBlogs />} />
                        <Route path="/forum" element={<EmployeeForum />} />
                        <Route path="/blogs/create" element={<CreateEditBlog />} />
                        <Route path="/blogs/edit/:id" element={<CreateEditBlog />} />

                        <Route path="/admin/blog-approvals" element={<BlogApprovals />} />

                        <Route path="/admin/manage-blogs" element={<ManageBlogs />} />
                        <Route path="/all-blogs" element={<AllBlogs />} />

                        <Route path="/blogs/view/:id" element={<ViewBlog />} />
                        <Route path="/funzone" element={<FridayFunZone />} />


                        <Route path="*" element={<Navigate to="/dashboard" replace />} />
                    </Routes>
                </main>
            </div>
        </div>
    );
};

export default Dashboard;